import { RawHtml } from "./ContentRaw";
import { html, mount } from './app';
import { memo } from "./memo";
import { Directives, DirectiveFunc } from "./Directives";
import {WebComponent} from "./WebComponent";

const raw= (html:string)=> new RawHtml(html);

const directive= (name:string, f:DirectiveFunc) => Directives.set(name,f);

/** @deprecated Use .mount or extend .WebComponent instead */
const app=(el:string|Element,render:()=>any)=> {
  return {redraw:mount(el,render)};
}

(<any>globalThis).Katla={app,html,mount,raw,directive,memo,WebComponent};
(<any>globalThis).html=html;
